import { render, staticRenderFns } from "./BICustomerRenewalDashboard.vue?vue&type=template&id=1e3b87c3&scoped=true&class=All"
import script from "./BICustomerRenewalDashboard.vue?vue&type=script&lang=ts"
export * from "./BICustomerRenewalDashboard.vue?vue&type=script&lang=ts"
import style0 from "./BICustomerRenewalDashboard.vue?vue&type=style&index=0&id=1e3b87c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b87c3",
  null
  
)

export default component.exports